import React, { useEffect } from 'react';
import { TextLoadingPlaceholder, InformationBox } from '@app/core';
import { useCreateIntent } from '@app/api';
import { PaymentMethodForm } from './PaymentMethodForm';
import { StripeProvider } from '../Stripe';
import { PaymentMethodContainer } from './PaymentMethodContainer';
import { useTranslation } from 'react-i18next';

interface Props {
  organizationId: string;
  onSuccess?: (pm: string) => any;
  onCancel?: () => any;
  selectableStyle?: boolean;
  sessionId?: string;
}

export const AddPaymentMethod = ({
  organizationId,
  onSuccess,
  onCancel,
  selectableStyle,
  sessionId,
}: Props) => {
  const { t } = useTranslation();
  const redirectTo = `${window.location.origin}/settings/billing`;

  const {
    mutate: createIntent,
    data: intent,
    isLoading: isIntentCreating,
    error,
  } = useCreateIntent(organizationId);

  useEffect(() => {
    if (!organizationId) {
      return;
    }
    createIntent();
  }, [organizationId, createIntent]);

  if (isIntentCreating || (!intent && !error)) {
    return (
      <PaymentMethodContainer selectable={selectableStyle}>
        <TextLoadingPlaceholder sample="Visa 1231 1234 1234 1200" />
      </PaymentMethodContainer>
    );
  }

  if (!intent) {
    return (
      <InformationBox
        text={t('billing.paymentMethod.intentStatus.creationError')}
        variant="danger"
      />
    );
  }

  return (
    <StripeProvider clientSecret={intent.client_secret}>
      <PaymentMethodForm
        redirectTo={redirectTo}
        organizationId={organizationId}
        onSuccess={onSuccess}
        onCancel={onCancel}
        intentSecret={intent.client_secret}
        selectableStyle={selectableStyle}
        sessionId={sessionId}
      />
    </StripeProvider>
  );
};
